<template>
<div>
<footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
      <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
      is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
    </p>
  </div>
</footer>
</div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<!--footer positioning CSS from Kenal
footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    overflow:hidden;
}
-->
<style>
</style>